import React from 'react'

import { Link } from 'gatsby'

import Image from '@components/Content/Image/Image'
import Section from '@components/Section/Section'
import SectionContent from '@components/Section/SectionContent'
import SectionSubtitle from '@components/Section/SectionSubtitle'
import StyledTitle from '@components/Typography/StyledTitle'

import { ServicesSectionType } from '@contracts/Services'

import * as styles from './ServicesSection.module.scss'

interface Props {
	data: ServicesSectionType
}

const ServicesSection = React.forwardRef((props: Props, ref: React.ForwardedRef<HTMLDivElement>) => {
	return (
		<Section className={styles.section} type="wide" ref={ref}>
			{props.data.styledTitle && (
				<StyledTitle data={props.data.styledTitle} tag="h2" className={styles.sectionTitle} />
			)}
			<SectionSubtitle subtitle={props.data.subtext} />

			<SectionContent className={styles.content}>
				<ul className={styles.services}>
					{props.data.services.map(({ service }, index) => {
						return (
							<li key={`service-grid-${index}`} className={styles.service}>
								<Link to={service.uri}>
									<Image
										image={service.serviceOptions.icon}
										altText={service.title}
										className={styles.icon}
									/>
									<h3 className={styles.text}>{service.title}</h3>
								</Link>
							</li>
						)
					})}
				</ul>
			</SectionContent>
		</Section>
	)
})

export default ServicesSection
